require('./amazonGiftCardReturnConfirmation.scss');
// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { OKLink } = require('commonsComponents/OKLink');

// @ helpers
const {AMAZON_GIFT_CARD_RETURN} = require('constants/operationTypes');
const {FormattedText } = require('core/i18n').i18n;

// @ components
const AmazonGiftCardReturnErrorStep = require('components/amazonGiftCardReturn/amazonGiftCardReturnErrorStep');
const AmazonGiftCardReturnSuccessStep = require('components/amazonGiftCardReturn/amazonGiftCardReturnSuccessStep');
const AccountsBuyAmazonGiftCardError = require('components/accounts/accountsBuyAmazonGiftCard/accountsBuyAmazonGiftCardError/accountsBuyAmazonGiftCardError');
const SignaturePattern = require('components/signaturePattern/signaturePattern').SignaturePattern;
const SignaturePatternButton = require('components/signaturePattern/signaturePatternButton/signaturePatternButton');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKSectionBox } = require('commonsComponents/OKSectionBox');

//@utils
const { recordLinkV2, recordPath } = require("utilities/tagging");

// @constants
const {
    AMAZON_RETURN_GIFT_VOUCHER_CANCEL,
    AMAZON_RETURN_GIFT_VOUCHER_CONFIRM,
    AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS
} = require('constants/tagging');

class AmazonGiftCardReturnConfirmation extends React.Component {

    componentDidMount() {
        recordPath("cuenta/cheque-regalo-codigos/devolucion paso 1", '', AMAZON_GIFT_CARD_RETURN_TIPO_PROCESS, "paso 1");
    }

    handleConfirmBtnClick = () => {
        const { handleConfirmClick } = this.props;
        const customData = ({
            categoriaEvento: "cuenta/cheque-regalo-codigos/devolucion paso 1",
            accionEvento: AMAZON_RETURN_GIFT_VOUCHER_CONFIRM
        });
        recordLinkV2(customData);
        handleConfirmClick();
    }

    buildButtonSection = () => {
        const { isLoading } = this.props;
        const cancelLink = `/myprofile/accounts`;

        return (
            <div>
                <div className="amazon-gift-card-return-confirmation__cancel-link">
                    <OKLink
                        modifier="inherit-styles"
                        to={cancelLink}
                        onClick={() => {
                            const customData = ({
                                categoriaEvento: "cuenta/cheque-regalo-codigos/devolucion paso 1",
                                accionEvento: AMAZON_RETURN_GIFT_VOUCHER_CANCEL
                            });
                            recordLinkV2(customData);
                        }}
                    >
                        <FormattedText value="common-cancel" />
                    </OKLink>
                </div>
                <div className="pull-right">
                    <span className="amazon-gift-card-return-confirmation__confirm-btn">
                        <SignaturePatternButton id="btnAccountIntervenersRemove" loading={isLoading} onClick={this.handleConfirmBtnClick} >
                            <FormattedText value="common-confirm" />
                        </SignaturePatternButton>
                    </span>
                </div>
            </div>
        )
    }

    buildReturnConfirmationSection = () => {
        const title = <FormattedText value="amazonGiftCardReturn-confirmationTitle" />;
        const description = <FormattedText value="amazonGiftCardReturn-confirmationMessage" />;
        const helpText = <FormattedText value="amazonGiftCard-helpBoxDescription" />;
        const signaturePattern = (
            <SignaturePattern
                operationType={AMAZON_GIFT_CARD_RETURN}
            />
        );

        return (
            <div className="col-xs-12 col-md-offset-2 col-md-8">
                <OKSectionBox
                    title={title}
                    className="amazon-gift-card-return-confirmation"
                >
                    <div className="amazon-gift-card-return-confirmation__content">
                        {description}
                        <div className="amazon-gift-card-return-confirmation__separator"></div>
                        {signaturePattern}
                        <div className="amazon-gift-card-return-confirmation__help-text">{helpText}</div>
                    </div>
                    <div className="amazon-gift-card-return-confirmation__separator"></div>
                    {this.buildButtonSection()}
                </OKSectionBox>
            </div>
        );
    }

    render() {
        const { immAmazonGiftCard, immRetailLoan } = this.props;
        const consentStatus = immRetailLoan.get('acceptAmazonConsentsStatus');
        const hasErrorGettingConsentsStatus = immRetailLoan.get('hasErrorConsentsStatus');
        let content;

        if (immAmazonGiftCard.get('returnGiftCardFetching')) {
            content = <LoadingSection />;
        } else if (immAmazonGiftCard.get('returnGiftCardFailure') || hasErrorGettingConsentsStatus) {
            content = <AmazonGiftCardReturnErrorStep navigateToCodigos={this.props.navigateToCodigos} />
        } else if (immAmazonGiftCard.get('returnGiftCardSuccess')) {
            content = <AmazonGiftCardReturnSuccessStep navigateToCodigos={this.props.navigateToCodigos} />
        } else if (!__CONTACT_CENTER__ && consentStatus && (consentStatus !== 'ACCEPTED')) {
            content = (
                <AccountsBuyAmazonGiftCardError
                    showCancelButton={true}
                    showHelpText={true}
                    title={'amazonGiftCardReturn-errorConsentTitle'}
                    content={'amazonGiftCardReturn-errorConsentMessage'}
                    handleRetryClick={this.props.navigateToCodigos}
                />
            );
        } else {
            content = this.buildReturnConfirmationSection();
        }

        return content;
    }
}

AmazonGiftCardReturnConfirmation.propTypes = {
    accountId: PropTypes.string.isRequired,
    handleConfirmClick: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    immAccounts: PropTypes.object.isRequired,
    immAmazonGiftCard: PropTypes.object.isRequired,
    immRetailLoan: PropTypes.object.isRequired,
    isLoading: PropTypes.bool.isRequired,
    navigateToCodigos: PropTypes.func.isRequired,
};

module.exports = AmazonGiftCardReturnConfirmation;
